import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CreateCompanyForm from '@/components/app/CreateCompanyForm.vue'
import ListCompaniesTable from "@/components/app/ListCompaniesTable.vue";
import {ref} from 'vue'
import IsAdmin from "@/components/blocks/IsAdmin.vue";

// Define template refs

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyView',
  setup(__props) {

const companiesTable = ref()

// Define properties
const formCollapsed = ref<boolean>(true)

// Define functions
function companyCreatedHandler(item: any) {
  companiesTable.value.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(IsAdmin, null, {
      default: _withCtx(() => [
        _createVNode(CreateCompanyForm, { onCompanyCreated: companyCreatedHandler })
      ]),
      _: 1
    }),
    _createVNode(ListCompaniesTable, {
      ref_key: "companiesTable",
      ref: companiesTable
    }, null, 512)
  ], 64))
}
}

})